import {AfterViewInit, Component, DestroyRef, inject, Input, OnInit, ViewChild} from '@angular/core';
import {CreateTableComponent} from "@app/quarantine/shared/create-table/create-table.component";
import {DateInputConverter} from "@app/quarantine/shared/directives/data-input-type.directive";
import {DropdownComponent} from "@app/dropdown/dropdown.component";
import {
  EditQuarantinePlacementTableComponent
} from "@app/quarantine/shared/edit-quarantine-placement-table/edit-quarantine-placement-table.component";
import {LoadingAnimationComponent} from "@app/loading-animation/loading-animation.component";
import {ModalConfirmComponent} from "@app/quarantine/shared/modal-confirm/modal-confirm.component";
import {NgForOf, NgIf, NgSwitchCase} from "@angular/common";
import {
  QuarantinePlacementFooterComponent
} from "@app/quarantine/shared/quarantine-placement-footer/quarantine-placement-footer.component";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {
  OrganisationInterface,
  QuarantineDocumentPlacement,
  QuarantinePlacementFormInterface,
  QuarantinePlacementInterface,
  SelectedMedicineMedicalDevicesInterface,
  UpdateDocumentQuarantinePlacementInterface
} from "@app/quarantine/intrfaces/quarantine.interface";
import {TokenInterface} from "@app/Interfaces/token.interface";
import {jwtDecode} from "jwt-decode";
import {DocumentTypeInterfaces} from "@app/quarantine/intrfaces/quarantine-form.interface";
import {DataService} from "@app/shared/data.service";
import {QuarantineApiService} from "@app/quarantine/services/quarantine.api.service";
import {HelpersQuarantineService} from "@app/quarantine/services/helpers.service.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastService} from "@app/toast/toast.service";
import {catchError, fromEvent, of, switchMap, take, tap, throwError} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {InputModule} from "@app/input/input.module";
import {InputComponent} from "@app/input/input.component";
import {debounceTime, map} from "rxjs/operators";
import {RedistributionApiService} from "@app/redistribution/services/redistribution-api.service";
import {ErrorModule} from "@app/error/error.module";

@Component({
  selector: 'app-create-redistribution-request',
  templateUrl: './create-redistribution-request.component.html',
  styleUrls: ['./create-redistribution-request.component.scss'],
  standalone: true,
  imports: [
    LoadingAnimationComponent,
    NgForOf,
    NgIf,
    QuarantinePlacementFooterComponent,
    ReactiveFormsModule,
    InputModule,
    ErrorModule,
    NgSwitchCase,
    DropdownComponent
  ]
})
export class CreateRedistributionRequestComponent implements OnInit, AfterViewInit {
  destroyRef = inject(DestroyRef);
  isLoading = false;
  
  userOrganisations: Array<{ [key: string]: string | number | any[]}> = [];
  userOrganisationsForList: Array<string> = [];
  
  @ViewChild(InputComponent, {static: true}) searchInput: InputComponent | undefined;
  
  medicalDevices: Array< {tradeName: string, mnn: string, dosage: string, direction: string}> = [];
  selectedMedicalDevice!: {tradeName: string, mnn: string, dosage: string, direction: string} | null;
  selectedMedicalDeviceError = false;
  amount  = null;
  maxAmount = null;
  maxAmountError = false;
  isAmountError = false;
  
  form!: FormGroup;
  
  
  constructor(
      private fb: FormBuilder,
      private dataService: DataService,
      private router: Router,
      private toastService: ToastService,
      private redistributionApiService: RedistributionApiService,
      private activatedRoute: ActivatedRoute,
  ) {
    this.initForm()
  }
  
  
  ngOnInit() {
    let breadcrumbs = [...this.activatedRoute.snapshot.data['breadcrumbs']]
    breadcrumbs.push({title: 'Створити запит на перерозподіл', link: ''});
    this.dataService.breadcrumbsArray.next(breadcrumbs)
    
    this.dataService.userOrganizationsValue
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data: Array<{ [key: string]: string | number | any[]}>) => {
          this.userOrganisations = data
          this.userOrganisationsForList = data.map(item => item['fullName'] as string)
        })
    
  }
  
  ngAfterViewInit() {

  }
  
  initForm() {
    this.form = this.fb.group({
      organizationId: ['', Validators.required],
      medicalDevice: ['', Validators.required],
    });
  }
  
  onSearch(value: any) {
    this.form.controls['medicalDevice'].setValue(value);
    this.isLoading = true;
    this.isAmountError = false;
    this.selectedMedicalDeviceError = false;
    
    this.redistributionApiService.getUniqMedicalDevicesRedistributionRequest(value)
        .pipe(
            catchError((error: any) => {
              console.log(error);
              this.isLoading = false;
              return of([])
            })
        )
        .subscribe((value) => {
          this.medicalDevices = value;
          this.isLoading = false;
          
        });
  }
  
  createRedistributionRequest() {
    this.form.markAllAsTouched();
    
    if (this.form.invalid) {
      return;
    }
    
    // @ts-ignore
    if (!this.selectedMedicalDevice) {
      this.toastService.showError('Оберіть медичний товар зі списку, щоб продовжити.');
      this.selectedMedicalDeviceError = true;
      return;
    }
    
    if (!this.amount || this.amount < 1) {
      this.isAmountError = true;
      return;
    } else {
      this.isAmountError = false;
    }
    
    this.isLoading = true;
    
    
    this.redistributionApiService.createRedistributionRequest(
        {
          // @ts-ignore
          amount: this.amount,
          mnn: this.selectedMedicalDevice.mnn,
          direction: this.selectedMedicalDevice.direction,
          dosage: this.selectedMedicalDevice.dosage,
          tradeName: this.selectedMedicalDevice.tradeName,
          organizationId: this.form.controls['organizationId'].value
        }
    )
        .pipe(catchError(err => {
          console.log(err);
          
          if (err.status === 400 && err.error.messages[1].includes('The quantity of requested medical good exceeds the total available quantity in the system, e.g.')) {
            const match = err.error.messages[1].match(/\d+/);
            this.maxAmount = match[0];
            this.maxAmountError = true;
          } else if (err && err.error && err.error.messages && err.error.messages.length) {
            this.toastService.showError(err.error.messages[1]);
          } else {
            this.toastService.showError();
          }
          this.isLoading = false;
          return throwError(() => err);
        }))
        .subscribe((data) => {
          this.isLoading = false;
          this.toastService.showSuccess('Запис успішно створено');
          this.router.navigate([`redistributions/requests/${data.id}`]);
        })
  }
  
  changeMedicalDevice(data: any) {
    this.selectedMedicalDevice = data;
    this.amount = null;
    this.maxAmountError = false;
    this.maxAmount = null;
    this.isAmountError = false;
  }
  
  onChangeAmount(e: any) {
    this.amount = e.target.value;
  }
  
  returnToList() {
    this.router.navigate(['redistributions/requests']);
  }
  
  onSelectOrganization(e: string) {
    // @ts-ignore
    this.form.controls['organizationId'].setValue(this.userOrganisations.find(el => el['fullName'] === e)['id']);
  }
  
  protected readonly encodeURI = encodeURI;
}
